import type { ReactNode } from "react";
import { useAuth } from "../../../auth/shared/hooks/useAuth";
import Button from "../../../../shared/components/Button";
import LeagueFeedback from "../../shared/components/LeagueFeedback";
import { getLeagueTexts } from "../../shared/leagueTexts";

export default function LeagueOrganizerAccess({ children }: { children: ReactNode }) {
  const { loading, isStaff } = useAuth();
  const t = getLeagueTexts();
  if (loading) return <LeagueFeedback>{t.loading}</LeagueFeedback>;
  if (!isStaff) return <LeagueFeedback>{t.access} <Button href="#/login" variant="ghost">{t.login}</Button></LeagueFeedback>;
  return <>{children}</>;
}
